/**
 * PublicLayout - Layout for public pages (landing, signup, santinho)
 *
 * Wraps public pages with TenantProvider and ThemeProvider.
 */

import { Outlet } from 'react-router-dom';
import { TenantProvider } from '@/contexts/TenantContext';
import { ThemeProvider } from '@/contexts/ThemeContext';

export function PublicLayout() {
  return (
    <TenantProvider>
      <ThemeProvider>
        <Outlet />
      </ThemeProvider>
    </TenantProvider>
  );
}
